import FabricInventoryType from "./actionTypes"



// function that called as action
const getListPage = data => ({
  type: FabricInventoryType.GET_FABRIC_INVENTORY_PAGES,
  payload: data,
})

// function to update state in reducer when fetching api is succeed or failed
const getListPageSuccess = data => ({
  type: FabricInventoryType.GET_FABRIC_INVENTORY_PAGES_SUCCESS,
  payload: data,
})

// function that called as action
const getDetail = (data, action) => ({
  type: FabricInventoryType.GET_DETAIL_FABRIC_INVENTORY_BY_ID,
  payload: data,
  action
})

// function to update state in reducer when fetching api is succeed or failed
const getDetailSuccess = data => ({
  type: FabricInventoryType.GET_DETAIL_FABRIC_INVENTORY_BY_ID_SUCCESS,
  payload: data,
})


// function that called as action
const putData = (data, action) => {
  return {
    type: FabricInventoryType.PUT_FABRIC_INVENTORY,
    payload: data,
    action
  }
}

// function to update state in reducer when fetching api is succeed or failed
const putDataSuccess = data => ({
  type: FabricInventoryType.PUT_FABRIC_INVENTORY_SUCCESS,
  payload: data,
})


// function that called as action
const getDetailPage = (data, action) => ({
  type: FabricInventoryType.GET_FABRIC_INVENTORY_DETAIL_PAGES,
  payload: data,
  action,

})

// function to update state in reducer when fetching api is succeed or failed
const getDetailPageSuccess = data => ({
  type: FabricInventoryType.GET_FABRIC_INVENTORY_DETAIL_PAGES_SUCCESS,
  payload: data,
})


const FabricInventoryAction = {
  getListPage,
  getListPageSuccess,


  getDetail,
  getDetailSuccess,

  putData,
  putDataSuccess,

  getDetailPage,
  getDetailPageSuccess,

}

export default FabricInventoryAction





